
function initMegaMenuClickImages() {
    document.querySelectorAll('[data-mega-menu-root]').forEach(menuRoot => {
        console.log('menuRoot', menuRoot)
        const hoverPanels = menuRoot.querySelectorAll('.mega-menu__hover-panel')

        if (!hoverPanels.length) return

        const hoverSwapEnabled = menuRoot.dataset.enableHoverSwap === 'true'

        if (hoverSwapEnabled) {
            initSwapMode(menuRoot, hoverPanels)
        } else {
            initPanelMode(menuRoot, hoverPanels)
        }
    })
}

/**
 * Swap mode: the closest image (image 1) is replaced in place on hover.
 */
function initSwapMode(menuRoot, hoverPanels) {
    const swapContainer = menuRoot.querySelector('[data-swap-image]')
    const swapImg = swapContainer ? swapContainer.querySelector('img') : null

    if (!swapImg) return

    const originalSrc = swapImg.src
    const originalSrcset = swapImg.srcset

    const ctaEl = menuRoot.querySelector('.mega-menu__promo-default .button-outlined')
    const imageLinkEl = menuRoot.querySelector('.mega-menu__promo-default .image-link')
    const ctaLabelEl = ctaEl ? ctaEl.querySelector('.button-outlined__label') : null
    const originalCtaHref = ctaEl ? ctaEl.getAttribute('href') : null
    const originalCtaLabel = ctaLabelEl ? ctaLabelEl.textContent : null

    function swapTo(targetKey) {
        const panel = [...hoverPanels].find(p => p.dataset.hoverTarget === targetKey)
        if (!panel) return
        const panelImg = panel.querySelector('img')
        if (panelImg) {
            swapImg.src = panelImg.src
            swapImg.srcset = panelImg.srcset || ''
        }
        if (ctaEl && panel.dataset.ctaUrl) {
            ctaEl.setAttribute('href', panel.dataset.ctaUrl)
            imageLinkEl.setAttribute('href', panel.dataset.ctaUrl)
        }
        if (ctaLabelEl && panel.dataset.ctaLabel) {
            ctaLabelEl.textContent = panel.dataset.ctaLabel
        }
        if (imageLinkEl && panel.dataset.ctaUrl) {
            imageLinkEl.setAttribute('href', panel.dataset.ctaUrl)
        }
    }

    function restoreOriginal() {
        swapImg.src = originalSrc
        swapImg.srcset = originalSrcset
        if (ctaEl && originalCtaHref !== null) ctaEl.setAttribute('href', originalCtaHref)
        if (ctaLabelEl && originalCtaLabel !== null) ctaLabelEl.textContent = originalCtaLabel
    }

    const links = [...menuRoot.querySelectorAll('[data-hover-id]')]

    links.forEach(link => {
        const hasPanel = [...hoverPanels].some(p => p.dataset.hoverTarget === link.dataset.hoverId)
        if (!hasPanel) return

        link.addEventListener('mouseenter', () => {
            swapTo(link.dataset.hoverId)
        })
    })

    menuRoot.querySelector('.mega-menu__linklist')?.addEventListener('mouseleave', () => {
        // restoreOriginal()
    })

    const detailsEl = menuRoot.closest('details')
    if (detailsEl) {
        detailsEl.addEventListener('toggle', () => {
            if (!detailsEl.open) restoreOriginal()
        })
    }
}

function initPanelMode(menuRoot, hoverPanels) {
    const defaultPanel = menuRoot.querySelector('.mega-menu__promo-default')
    let activeLink = null

    function showPanel(targetKey) {
        let matched = false
        hoverPanels.forEach(panel => {
            if (panel.dataset.hoverTarget === targetKey) {
                panel.hidden = false
                matched = true
            } else {
                panel.hidden = true
            }
        })
        if (defaultPanel) defaultPanel.hidden = matched
    }

    function resetPanels() {
        hoverPanels.forEach(panel => { panel.hidden = true })
        if (defaultPanel) defaultPanel.hidden = false
        if (activeLink) {
            activeLink.classList.remove('mega-menu__link--active')
            activeLink = null
        }
        const firstLink = [...menuRoot.querySelectorAll('[data-hover-id]')].find(link =>
            [...hoverPanels].some(p => p.dataset.hoverTarget === link.dataset.hoverId)
        )
        if (firstLink) {
            activeLink = firstLink
            firstLink.classList.add('mega-menu__link--active')
            showPanel(firstLink.dataset.hoverId)
        }
    }

    const links = [...menuRoot.querySelectorAll('[data-hover-id]')]

    links.forEach(link => {
        link.addEventListener('click', (e) => {
            const targetKey = link.dataset.hoverId
            const hasPanel = [...hoverPanels].some(p => p.dataset.hoverTarget === targetKey)

            if (!hasPanel) return

            e.preventDefault()

            if (activeLink && activeLink !== link) {
                activeLink.classList.remove('mega-menu__link--active')
            }

            activeLink = link
            link.classList.add('mega-menu__link--active')
            showPanel(targetKey)
        })
    })

    const firstLink = links.find(link =>
        [...hoverPanels].some(p => p.dataset.hoverTarget === link.dataset.hoverId)
    )
    if (firstLink) {
        activeLink = firstLink
        firstLink.classList.add('mega-menu__link--active')
        showPanel(firstLink.dataset.hoverId)
    }

    const detailsEl = menuRoot.closest('details')
    if (detailsEl) {
        detailsEl.addEventListener('toggle', () => {
            if (!detailsEl.open) resetPanels()
        })
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuClickImages)
} else {
    initMegaMenuClickImages()
}
